module.exports = __webpack_public_path__ + "img/running-profile.fbb2421d.svg";